"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConstant = void 0;
var react_1 = require("react");
var useConstant = function (fn, dependencies) {
    var _a = (0, react_1.useState)(false), init = _a[0], setInit = _a[1];
    var _b = (0, react_1.useState)(), value = _b[0], setValue = _b[1];
    if (!init && dependencies.every(function (e) { return !!e; })) {
        setValue(fn);
        setInit(true);
    }
    return value;
};
exports.useConstant = useConstant;
exports.default = exports.useConstant;
